import { DataService } from "../../core/services/data.service";
import { NotificationService } from "../../core/services/notification.service";
import { HttpClient } from "@angular/common/http";
import { ListViewModel } from "../models/core/ListViewModel";
import { Observable } from "rxjs";
import { LaboratoryCertificateRequiringDto } from "../models/laboratory/laboratory-certificate-requirings.dto";
import { ActionDataResult } from "../models/core/ActionDataResult";
import { take } from "rxjs/operators";
import { LaboratoryExaminationObjectDto } from "../models/laboratory/laboratory-examination-objects.dto";
import { LaboratoryExaminationTargetDto } from "../models/laboratory/laboratory-examination-targets.dto";
import { LaboratoryExaminationTypeDto } from "../models/laboratory/laboratory-examination-types.dto";
import { LaboratoryMaterialSourceDto } from "../models/laboratory/laboratory-material-sources.dto";
import { LaboratoryRecommendationDto } from "../models/laboratory/laboratoy-recommendations.dto";
import { LaboratoryResultDeliveryTypeDto } from "../models/laboratory/laboratory-result-delivery-types.dto";
import { LaboratorySamplingPointDto } from "../models/laboratory/laboratory-sampling-points.dto";
import { Injectable } from "@angular/core";
import { LaboratoryExaminationTypeIndicatorDto } from "../models/laboratory/laboratory-examination-type-indicator.dto";
import { LaboratoryIndicatorDto } from "../models/laboratory/laboratory-indicator.dto";
import { LaboratorySamplingPerformerDto } from "../models/laboratory/laboratory-sampling-performer.dto";
import { LaboratorySampleDeliveryPerformerDto } from "../models/laboratory/laboratory-sample-delivery-performer.dto";
import { LaboratorySampleLeftoverActionDto } from "../models/laboratory/laboratory-sample-leftover-action.dto";
import { LaboratorySampleContainerVisualDamageDto } from "../models/laboratory/laboratory-sample-container-visual-damage.dto";
import { LaboratorySampleContainerRequirementDto } from "../models/laboratory/laboratory-sample-container-requirement.dto";
import { LaboratoryDeliveryTimeRequirementDto } from "../models/laboratory/laboratory-delivery-time-requirement.dto";
import { LaboratorySampleContainerTypeDto } from "../models/laboratory/laboratory-sample-container-type.dto";
import { LaboratorySamplePreserveDto } from "../models/laboratory/laboratory-sample-preserve.dto";
import { LaboratorySpecialMarkDto } from "../models/laboratory/laboratory-special-mark.dto";
import { LaboratoryExaminationMethodListItem } from "../models/laboratory/laboratory-examination-method-list-item";
import { LaboratoryExaminationEquipmentDto } from "../models/laboratory/laboratory-examination-equipment.dto";
import { LaboratoryWaterSamplingConditionDto } from "../models/laboratory/laboratory-water-sampling-condition.dto";
import { LaboratoryWaterSamplingMethodDto } from "../models/laboratory/laboratory-water-sampling-method.dto";
import { LaboratoryWaterSamplingRegulatoryDocumentDto } from "../models/laboratory/laboratory-water-sampling-regulatory-document.dto";

@Injectable()
export class LaboratoriesService extends DataService<any, any> {
    
    constructor(http: HttpClient, notificationService: NotificationService) {
        super(http, notificationService);
        this.controllerName = 'laboratories';
    }

    getAllCertificateRequirings(): Observable<ListViewModel<LaboratoryCertificateRequiringDto>> {
        return this.http.get<ActionDataResult<ListViewModel<LaboratoryCertificateRequiringDto>>>(
            `${this.baseUrl()}/certificate-requirings`)
            .pipe(take(1))
            .map(x => x.data);
    }

    getAllExaminationObjects(): Observable<ListViewModel<LaboratoryExaminationObjectDto>> {
        return this.http.get<ActionDataResult<ListViewModel<LaboratoryExaminationObjectDto>>>(
            `${this.baseUrl()}/examination-objects`)
            .pipe(take(1))
            .map(x => x.data);
    }

    getAllExaminationTargets(): Observable<ListViewModel<LaboratoryExaminationTargetDto>> {
        return this.http.get<ActionDataResult<ListViewModel<LaboratoryExaminationTargetDto>>>(
            `${this.baseUrl()}/examination-targets`)
            .pipe(take(1))
            .map(x => x.data);
    }

    getAllExaminationTypes(): Observable<ListViewModel<LaboratoryExaminationTypeDto>> {
        return this.http.get<ActionDataResult<ListViewModel<LaboratoryExaminationTypeDto>>>(
            `${this.baseUrl()}/examination-types`)
            .pipe(take(1))
            .map(x => x.data);
    }

    getAllMaterialSources(): Observable<ListViewModel<LaboratoryMaterialSourceDto>> {
        return this.http.get<ActionDataResult<ListViewModel<LaboratoryMaterialSourceDto>>>(
            `${this.baseUrl()}/material-sources`)
            .pipe(take(1))
            .map(x => x.data);
    }

    getAllRecommendations(): Observable<ListViewModel<LaboratoryRecommendationDto>> {
        return this.http.get<ActionDataResult<ListViewModel<LaboratoryRecommendationDto>>>(
            `${this.baseUrl()}/recommendations`)
            .pipe(take(1))
            .map(x => x.data);
    }

    getAllResultDeliveryTypes(): Observable<ListViewModel<LaboratoryResultDeliveryTypeDto>> {
        return this.http.get<ActionDataResult<ListViewModel<LaboratoryResultDeliveryTypeDto>>>(
            `${this.baseUrl()}/result-delivery-types`)
            .pipe(take(1))
            .map(x => x.data);
    }

    getAllSamplingPoints(): Observable<ListViewModel<LaboratorySamplingPointDto>> {
        return this.http.get<ActionDataResult<ListViewModel<LaboratorySamplingPointDto>>>(
            `${this.baseUrl()}/sampling-points`)
            .pipe(take(1))
            .map(x => x.data);
    }

    getAllExaminationTypeIndicators(): Observable<ListViewModel<LaboratoryExaminationTypeIndicatorDto>> {
        return this.http.get<ActionDataResult<ListViewModel<LaboratoryExaminationTypeIndicatorDto>>>(
            `${this.baseUrl()}/examination-type-indicators`)
            .pipe(take(1))
            .map(x => x.data);
    }

    getAllIndicators(): Observable<ListViewModel<LaboratoryIndicatorDto>> {
        return this.http.get<ActionDataResult<ListViewModel<LaboratoryIndicatorDto>>>(
            `${this.baseUrl()}/indicators`)
            .pipe(take(1))
            .map(x => x.data);
    }

    getAllSamplingPerformers(): Observable<ListViewModel<LaboratorySamplingPerformerDto>> {
        return this.http.get<ActionDataResult<ListViewModel<LaboratorySamplingPerformerDto>>>(
            `${this.baseUrl()}/sampling-performers`)
            .pipe(take(1))
            .map(x => x.data);
    }

    getAllSampleDeliveryPerformers(): Observable<ListViewModel<LaboratorySampleDeliveryPerformerDto>> {
        return this.http.get<ActionDataResult<ListViewModel<LaboratorySampleDeliveryPerformerDto>>>(
            `${this.baseUrl()}/sampling-delivery-performers`)
            .pipe(take(1))
            .map(x => x.data);
    }

    getAllSampleLeftoverActions(): Observable<ListViewModel<LaboratorySampleLeftoverActionDto>> {
        return this.http.get<ActionDataResult<ListViewModel<LaboratorySampleLeftoverActionDto>>>(
            `${this.baseUrl()}/leftover-actions`)
            .pipe(take(1))
            .map(x => x.data);
    }

    getAllSampleContainerVisualDamages(): Observable<ListViewModel<LaboratorySampleContainerVisualDamageDto>> {
        return this.http.get<ActionDataResult<ListViewModel<LaboratorySampleContainerVisualDamageDto>>>(
            `${this.baseUrl()}/sample-container-visual-damages`)
            .pipe(take(1))
            .map(x => x.data);
    }

    getAllSampleContainerRequirements(): Observable<ListViewModel<LaboratorySampleContainerRequirementDto>> {
        return this.http.get<ActionDataResult<ListViewModel<LaboratorySampleContainerRequirementDto>>>(
            `${this.baseUrl()}/sample-container-requirements`)
            .pipe(take(1))
            .map(x => x.data);
    }

    getAllDeliveryTimeRequirements(): Observable<ListViewModel<LaboratoryDeliveryTimeRequirementDto>> {
        return this.http.get<ActionDataResult<ListViewModel<LaboratoryDeliveryTimeRequirementDto>>>(
            `${this.baseUrl()}/delivery-time-requirements`)
            .pipe(take(1))
            .map(x => x.data);
    }

    getAllSampleContainerTypes(): Observable<ListViewModel<LaboratorySampleContainerTypeDto>> {
        return this.http.get<ActionDataResult<ListViewModel<LaboratorySampleContainerTypeDto>>>(
            `${this.baseUrl()}/sample-container-types`)
            .pipe(take(1))
            .map(x => x.data);
    }

    getAllSamplePreserves(): Observable<ListViewModel<LaboratorySamplePreserveDto>> {
        return this.http.get<ActionDataResult<ListViewModel<LaboratorySamplePreserveDto>>>(
            `${this.baseUrl()}/sample-preserves`)
            .pipe(take(1))
            .map(x => x.data);
    }

    getAllSpecialMarks(): Observable<ListViewModel<LaboratorySpecialMarkDto>> {
        return this.http.get<ActionDataResult<ListViewModel<LaboratorySpecialMarkDto>>>(
            `${this.baseUrl()}/special-marks`)
            .pipe(take(1))
            .map(x => x.data);
    }

    getAllExaminationMethods(): Observable<ListViewModel<LaboratoryExaminationMethodListItem>> {
        return this.http.get<ActionDataResult<ListViewModel<LaboratoryExaminationMethodListItem>>>(
            `${this.baseUrl()}/examination-methods`)
            .pipe(take(1))
            .map(x => x.data);
    }

    getAllExaminationEquipments(): Observable<ListViewModel<LaboratoryExaminationEquipmentDto>> {
        return this.http.get<ActionDataResult<ListViewModel<LaboratoryExaminationEquipmentDto>>>(
            `${this.baseUrl()}/examination-equipments`)
            .pipe(take(1))
            .map(x => x.data);
    }

    getAllLaboratoryWaterSamplingConditions(): Observable<ListViewModel<LaboratoryWaterSamplingConditionDto>> {
        return this.http.get<ActionDataResult<ListViewModel<LaboratoryWaterSamplingConditionDto>>>(
            `${this.baseUrl()}/sampling-conditions`)
            .pipe(take(1))
            .map(x => x.data);
    }

    getAllLaboratoryWaterSamplingMethods(): Observable<ListViewModel<LaboratoryWaterSamplingMethodDto>> {
        return this.http.get<ActionDataResult<ListViewModel<LaboratoryWaterSamplingMethodDto>>>(
            `${this.baseUrl()}/sampling-methods`)
            .pipe(take(1))
            .map(x => x.data);
    }

    getAllLaboratoryWaterSamplingRegulatoryDocuments(): Observable<ListViewModel<LaboratoryWaterSamplingRegulatoryDocumentDto>> {
        return this.http.get<ActionDataResult<ListViewModel<LaboratoryWaterSamplingRegulatoryDocumentDto>>>(
            `${this.baseUrl()}/regulatory-documents`)
            .pipe(take(1))
            .map(x => x.data);
    }
}